import { AxisScale } from '@visx/axis';

export default function getScaleBandwidth<Scale extends AxisScale>(
  scale?: Scale,
) {
  const s = scale as AxisScale;
  return s && 'bandwidth' in s ? s?.bandwidth() ?? 0 : 0;
}
